import { IconButton, styled } from "@mui/material";

export const StyledClearButton = styled(IconButton)`
  &&& {
    color: ${(props) => props.theme.wsc.palette.neutral[100]};
    padding: 0;
    outline: none;

    &:hover,
    &:focus {
      background: none;
    }

    .MuiSvgIcon-root {
      font-size: ${(props) => props.theme.wsc.typography.header4.fontSize};
    }
  }
`;
